// /**
//  * useModalFocus.ts
//  * モーダルのフォーカスとキーイベント制御用ディレクティブ
//  */
// import type { DirectiveBinding } from "vue";

// const handleTabKey = async (
//   event: KeyboardEvent,
//   modalElement: HTMLElement
// ) => {
//   const focusableElements = Array.from(
//     modalElement.querySelectorAll("input, button, select, textarea, a[href]")
//   ) as HTMLElement[];

//   if (focusableElements.length === 0) return;

//   const firstElement = focusableElements[0];
//   const lastElement = focusableElements[focusableElements.length - 1];

//   if (event.shiftKey) {
//     if (document.activeElement === firstElement) {
//       setTimeout(() => {
//         lastElement.focus();
//         event.preventDefault();
//       }, 100);
//       //lastElement.focus();
//       //event.preventDefault();
//     }
//   } else {
//     if (document.activeElement === lastElement) {
//       firstElement.focus();
//       event.preventDefault();
//     }
//   }
// };

// const handleEnterKey = (event: KeyboardEvent, modalElement: HTMLElement) => {
//   if (modalElement.contains(document.activeElement)) {
//     if (document.activeElement !== document.querySelector("textarea")) {
//       event.preventDefault();
//     }
//   }
// };

// /**
//  * v-modal-focus ディレクティブ
//  */
// export const vModalFocus = {
//   mounted(el: HTMLElement) {
//     const handleKeyDown = (event: KeyboardEvent) => {
//       if (event.key === "Tab") {
//         handleTabKey(event, el);
//       } else if (event.key === "Enter") {
//         handleEnterKey(event, el);
//       }
//     };

//     el.dataset.keydownHandler = handleKeyDown.toString(); // イベントリスナー識別用

//     document.addEventListener("keydown", handleKeyDown);

//     // 初期フォーカス
//     const focusableElement = el.querySelector(
//       "input, button, select, textarea, a[href]"
//     );
//     (focusableElement as HTMLElement)?.focus();
//   },

//   unmounted(el: HTMLElement) {
//     const handler = el.dataset.keydownHandler;
//     if (handler) {
//       document.removeEventListener("keydown", eval(handler));
//       delete el.dataset.keydownHandler;
//     }
//   },
// };
// v-modal-focus.ts
import type { Directive } from "vue";

// el に紐づくイベントハンドラを保持する
const keydownHandlerMap = new WeakMap<HTMLElement, (e: KeyboardEvent) => void>();

const getFocusableElements = (el: HTMLElement): HTMLElement[] => {
  return Array.from(
    el.querySelectorAll<HTMLElement>("input, button, select, textarea, a[href]")
  ).filter(el => !el.hasAttribute("disabled") && !el.hasAttribute("tabindex"));
};

const handleTabKey = (event: KeyboardEvent, modalEl: HTMLElement) => {
  const focusableElements = getFocusableElements(modalEl);
  if (focusableElements.length === 0) return;

  const first = focusableElements[0];
  const last = focusableElements[focusableElements.length - 1];

  if (event.shiftKey) {
    if (document.activeElement === first) {
      event.preventDefault();
      last.focus();
    }
  } else {
    if (document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
};

const handleEnterKey = (event: KeyboardEvent, modalEl: HTMLElement) => {
  const active = document.activeElement;
  if (modalEl.contains(active) && active?.tagName.toLowerCase() !== "textarea") {
    event.preventDefault();
  }
};

export const vModalFocus: Directive<HTMLElement> = {
  mounted(el) {
    const handler = (event: KeyboardEvent) => {
      if (event.key === "Tab") {
        handleTabKey(event, el);
      } else if (event.key === "Enter") {
        handleEnterKey(event, el);
      }
    };

    keydownHandlerMap.set(el, handler);
    document.addEventListener("keydown", handler);

    // 初期フォーカスをセット
    const first = getFocusableElements(el)[0];
    first?.focus();
  },

  unmounted(el) {
    const handler = keydownHandlerMap.get(el);
    if (handler) {
      document.removeEventListener("keydown", handler);
      keydownHandlerMap.delete(el);
    }
  }
};
